'use client'
import { ReactNode, useEffect } from 'react'

import QueryInfo from './query-info'

import useSuspenseGetDetailProfile from '@/libs/apis/queries/use-suspense-get-detail-profile'
import { useAppDispatch } from '@/libs/hooks/use-app-dispatch'
import {
  setCurrentUserEmail,
  setCurrentUserFullname,
  setCurrentUserId,
  setCurrentUserPhone,
  setCurrentUserUsername,
} from '@/libs/store/slice/user-slice'

const User = ({ children }: { children?: ReactNode }) => {
  const dispatch = useAppDispatch()
  const { data: profile, dataUpdatedAt } = useSuspenseGetDetailProfile()

  useEffect(() => {
    if (!!profile) {
      // this should not required if all the user state is already migrated to the server state
      dispatch(setCurrentUserEmail(profile?.data?.result?.email))
      dispatch(setCurrentUserUsername(profile?.data?.result?.email))
      dispatch(setCurrentUserFullname(profile?.data?.result?.fullName))
      dispatch(setCurrentUserPhone(profile?.data?.result?.phoneNumber))
      dispatch(setCurrentUserId(profile?.data?.result?.id))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUpdatedAt])

  return (
    profile?.data?.result?.email && (
      <QueryInfo username={profile?.data?.result?.email}>{children}</QueryInfo>
    )
  )
}

export default User
